import "../styles/Footer.css";

function Footer() {
  return (
    <div id="copyright">
      <p>Copyright &copy; {new Date().getFullYear()} @RKIndustrialAutomation</p>
    </div>
  );
}

export default Footer;
